export const colors = {
    mapBgPointColor: '#cccccc',
    mapFill: '#283f75',
    mapFill_alpha: '#283f7520',
    highlight: '#ffff00',
    highlight_alpha: '#ffff0080',
    highlight_alpha_current: '#ffff00E6',
    mapError: 'red',
    mapSurroundingFill: '#808080', // gray,
    mapRefLine: '#FFA500', // 'orange',
    mapRefFill_alpha: '#ffffff80',
    deleted: '#f2790061',
    mapLabel: '#303030',
    mapPink: 'pink',
    // topo
    overlapHex: '#FF0000', //'red'
    gapHex: '#00FF00', // 'green'
    creviceHex: '#d04ef0' // 'purple' '#0000FF', // 'blue';
}
export const styleAttrs = {
    fishboneRoadStrokeWidth: 3,
    fishboneStrikeStrokeWidth: 1,
    fishboneRefStrokeWidth: 1,
    deletedLineDash: [4, 12]
}